import { lazy, Suspense, useEffect, useState } from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./button";

const FaleComEspecialistaFormDialog = lazy(() => import("./FaleComEspecialistaFormDialog"));

interface FaleComEspecialistaFormProps {
  buttonClassName?: string;
  variant?: "link" | "default" | "destructive" | "outline" | "secondary" | "ghost";
  iconDisplay?: "left" | "right" | "none";
  text?: string;
  controled?: boolean;
  state?: boolean;
  handleIsOpen?: (value: boolean) => void;
  /** "Q" (Qualidade do Fornecimento) | "D" (Disponibilização da Fatura) — repassado
   * pro dialog, que mostra o radio "Tipo de serviço" pré-selecionado quando definido. */
  tipoServico?: "Q" | "D";
}

function FaleComEspecialistaForm({
  buttonClassName,
  variant,
  handleIsOpen,
  iconDisplay = "left",
  text = "Fale com um especialista",
  state = false,
  controled = false,
  tipoServico
}: FaleComEspecialistaFormProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const isOpen = controled ? state : internalOpen;

  useEffect(() => {
    if (isOpen) setHasOpened(true);
  }, [isOpen]);

  const handleOpen = (value: boolean) => {
    if (!controled) setInternalOpen(value);
    handleIsOpen?.(value);
  };

  return (
    <>
      {!controled && (
        <div>
          <Button
            size="lg"
            className={buttonClassName ? cn(buttonClassName) : undefined}
            onClick={() => handleOpen(true)}
            variant={variant}
          >
            {iconDisplay === "left" && <MessageCircle className="mr-2 h-5 w-5" />}
            {text}
            {iconDisplay === "right" && <ArrowRight className="ml-2 h-5 w-5" />}
          </Button>
        </div>
      )}
      {hasOpened && (
        <Suspense fallback={null}>
          <FaleComEspecialistaFormDialog isOpen={isOpen} onOpenChange={handleOpen} tipoServico={tipoServico} />
        </Suspense>
      )}
    </>
  );
}

export default FaleComEspecialistaForm;
